(function () {
  var loaderScript = document.currentScript;
  var runtimeUrl = loaderScript && loaderScript.getAttribute('data-runtime-src');
  var runtimePromise = null;

  function loadRuntime(reason) {
    if (window.__PDPV3_RUNTIME_LOADED__ === true) return Promise.resolve(true);
    if (runtimePromise) return runtimePromise;
    if (!runtimeUrl) return Promise.reject(new Error('Missing PDP visualiser runtime URL'));

    runtimePromise = new Promise(function (resolve, reject) {
      var previousHsUnblocked = window.hsUnblocked;
      window.hsUnblocked = true;
      var script;
      try {
        script = document.createElement('script');
      } finally {
        window.hsUnblocked = previousHsUnblocked;
      }
      script.src = runtimeUrl;
      script.async = true;
      script.setAttribute('data-pdpv3-runtime', 'true');
      script.onload = function () {
        window.__PDPV3_RUNTIME_LOADED__ = true;
        resolve(true);
      };
      script.onerror = function () {
        runtimePromise = null;
        reject(new Error('Unable to load PDP visualiser runtime'));
      };
      var appendHsUnblocked = window.hsUnblocked;
      window.hsUnblocked = true;
      try {
        document.head.appendChild(script);
      } finally {
        window.hsUnblocked = appendHsUnblocked;
      }
    });

    if (window.__PDP_MOBILE_PERF_STATS__) {
      window.__PDP_MOBILE_PERF_STATS__.runtimeLoadReason = reason || 'unknown';
    }
    return runtimePromise;
  }

  window.__pdpv3LoadRuntime = loadRuntime;

  function isSelectedSlide(slide) {
    if (!slide) return true;
    if (slide.getAttribute('aria-hidden') === 'true') return false;
    return slide.classList.contains('is-selected');
  }

  function isNearViewport(node) {
    if (!node || !node.getBoundingClientRect) return false;
    var rect = node.getBoundingClientRect();
    var height = window.innerHeight || document.documentElement.clientHeight || 0;
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    return rect.width > 0 && rect.height > 0 && rect.bottom > -240 && rect.top < height + 240 && rect.right > 0 && rect.left < width;
  }

  function setup() {
    var root = document.querySelector('[data-feature="visualiser-v3-mobile"] .pdpv3m-root');
    if (!root) return;
    var slide = root.closest ? root.closest('.product-main-slide') : null;

    function loadIfVisible(reason) {
      if (!isSelectedSlide(slide) || !isNearViewport(root)) return;
      loadRuntime(reason).catch(function () {});
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadIfVisible('visualiser-visible');
        });
      }, { rootMargin: '240px 0px', threshold: 0.01 });
      observer.observe(root);
    } else {
      loadIfVisible('visualiser-visible-fallback');
    }

    if (slide && typeof MutationObserver !== 'undefined') {
      var slideObserver = new MutationObserver(function () {
        loadIfVisible('visualiser-slide-selected');
      });
      slideObserver.observe(slide, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden']
      });
    }

    var intentSelector = [
      '[data-feature="visualiser-v3-mobile"]',
      '[data-feature="visualiser-v3-desktop"]'
    ].join(',');

    function loadFromIntent(event) {
      var target = event && event.target;
      if (!target || !target.closest || !target.closest(intentSelector)) return;
      loadRuntime('visualiser-intent').catch(function () {});
    }

    document.addEventListener('pointerdown', loadFromIntent, true);
    document.addEventListener('change', loadFromIntent, true);
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      loadFromIntent({ target: document.activeElement });
    }, true);

    document.addEventListener('um:sticky-preview-state', function (event) {
      if (!event || !event.detail || event.detail.open !== true) return;
      loadRuntime('sticky-preview').catch(function () {});
    });

    loadIfVisible('initial-visible-slide');
  }

  var forceEager = false;
  try {
    var loaderParams = new URLSearchParams(window.location.search || '');
    forceEager = String(loaderParams.get('pdpLazy') || '').toLowerCase() === 'eager' ||
      String(loaderParams.get('pdpPerf') || '').toLowerCase() === 'legacy';
  } catch (_) {}

  if (forceEager) loadRuntime('query-eager').catch(function () {});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
